import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fea8ccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cv-header flex" }
const _hoisted_2 = { class: "left-column" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "10",
  viewBox: "0 0 7 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.13257 0.293031C6.32004 0.480558 6.42535 0.734866 6.42535 1.00003C6.42535 1.26519 6.32004 1.5195 6.13257 1.70703L2.83957 5.00003L6.13257 8.29303C6.31473 8.48163 6.41552 8.73423 6.41324 8.99643C6.41096 9.25863 6.30579 9.50944 6.12039 9.69485C5.93498 9.88026 5.68417 9.98543 5.42197 9.9877C5.15977 9.98998 4.90717 9.88919 4.71857 9.70703L0.718568 5.70703C0.531097 5.5195 0.425781 5.26519 0.425781 5.00003C0.425781 4.73487 0.531097 4.48056 0.718568 4.29303L4.71857 0.293031C4.9061 0.10556 5.1604 0.000244141 5.42557 0.000244141C5.69073 0.000244141 5.94504 0.10556 6.13257 0.293031Z",
    fill: "#18181B"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "7",
  height: "10",
  viewBox: "0 0 7 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.718568 9.70704C0.531097 9.51951 0.425781 9.26521 0.425781 9.00004C0.425781 8.73488 0.531097 8.48057 0.718568 8.29304L4.01157 5.00004L0.718568 1.70704C0.53641 1.51844 0.435615 1.26584 0.437893 1.00364C0.440172 0.741443 0.545341 0.490631 0.730749 0.305223C0.916157 0.119815 1.16697 0.0146453 1.42917 0.0123669C1.69136 0.0100885 1.94397 0.110883 2.13257 0.293041L6.13257 4.29304C6.32004 4.48057 6.42535 4.73488 6.42535 5.00004C6.42535 5.26521 6.32004 5.51951 6.13257 5.70704L2.13257 9.70704C1.94504 9.89451 1.69073 9.99983 1.42557 9.99983C1.1604 9.99983 0.906096 9.89451 0.718568 9.70704Z",
    fill: "#18181B"
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "central-column flex-grow text-center" }
const _hoisted_10 = { class: "right-column text-right font-bold" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "previous-period",
        disabled: !_ctx.headerProps.previousPeriod,
        "aria-label": "Previous Period",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onInput(_ctx.headerProps.previousPeriod)), ["prevent"]))
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("button", {
        class: "current-period",
        "aria-label": "Current Period",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onInput(_ctx.headerProps.currentPeriod)), ["prevent"]))
      }, _toDisplayString(_ctx.headerProps.currentPeriodLabel), 1),
      _createElementVNode("button", {
        class: "next-period",
        disabled: !_ctx.headerProps.nextPeriod,
        "aria-label": "Next Period",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onInput(_ctx.headerProps.nextPeriod)), ["prevent"]))
      }, _hoisted_8, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createTextVNode(_toDisplayString(_ctx.headerProps.periodLabel), 1)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodButtons, (periodButton) => {
        return (_openBlock(), _createElementBlock("button", {
          key: periodButton.id,
          onClick: ($event: any) => (_ctx.switchPeriodUom(periodButton.id)),
          class: _normalizeClass({ selected: _ctx.displayPeriodUom == periodButton.id })
        }, _toDisplayString(periodButton.name), 11, _hoisted_11))
      }), 128))
    ])
  ]))
}